import { render } from "./ContentTable.vue?vue&type=template&id=da1df7d0&scoped=true&ts=true"
import script from "./ContentTable.vue?vue&type=script&lang=ts"
export * from "./ContentTable.vue?vue&type=script&lang=ts"

import "./ContentTable.vue?vue&type=style&index=0&id=da1df7d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da1df7d0"]])

export default __exports__